import type { Registry as Services } from '@ember/service';
import { tKey } from 'ember-intl';
import type { Ota } from 'frontend-utils/models';
import { PLATFORMS } from 'frontend-utils/utils/constants/constant-values';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import {
  RATE_INSIGHT_FILTER_TYPE_RATE_PARAM,
  RATE_PARAMS,
} from 'lumen/utils/constants/general-constants';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getRateParamOptions(
  selectedOTA: Ota | null,
  platform: number,
  intl: Services['intl'],
  hotelAndMarketService: HotelAndMarketServiceWithHotel,
) {
  const rateParams = [];

  if (selectedOTA?.hasCancellationFilter) {
    rateParams.push({
      label: intl.t(tKey('rates.bar_short')),
      icon: 'rates-best-flex' as const,
      id: RATE_PARAMS.BEST_FLEX,
      type: RATE_INSIGHT_FILTER_TYPE_RATE_PARAM,
      isComparable: true,
    });
  }

  if (selectedOTA?.hasFlexibleFilter) {
    rateParams.push({
      label: intl.t(tKey('rates.flexible')),
      icon: 'rates-semi-flex' as const,
      id: RATE_PARAMS.FLEXIBLE,
      type: RATE_INSIGHT_FILTER_TYPE_RATE_PARAM,
      isComparable: true,
    });
  }

  rateParams.push({
    label: intl.t(tKey('rates.lowest')),
    icon: 'rates-lowest' as const,
    id: RATE_PARAMS.LOWEST,
    type: RATE_INSIGHT_FILTER_TYPE_RATE_PARAM,
    isComparable: true,
  });

  const isMobileRates =
    platform === PLATFORMS.PLATFORM_MOBILE_WEBSITE ||
    platform === PLATFORMS.PLATFORM_MOBILE_APP;
  // Only on single property level, for enabled OTAs and not for mobile rates (unless we explicitely allow it)
  if (
    hotelAndMarketService.hotel &&
    selectedOTA?.hasThirdPartyFilter &&
    (!isMobileRates || selectedOTA?.isMobileThirdPartyRatesSupported)
  ) {
    rateParams.push({
      label: intl.t(tKey('rates.third_party')),
      icon: 'rates-third-party' as const,
      id: RATE_PARAMS.THIRD_PARTY,
      type: RATE_INSIGHT_FILTER_TYPE_RATE_PARAM,
      isComparable: true,
    });
  }

  return rateParams;
}
